import React, { createContext, useReducer } from "react";
import { authReducer } from "./AuthReducer";


// ESTADO INICIAL 
export const authInitialState = {
    idUser: 0,
    Usuario: '',
    UserName: '',
    Mail: '',
    IdRol: 0,
    Rol: '',
    IdStatus: 0,
    StatusCategory: 'Security',
    StatusName: 'Inactive',
    isLogged: false,
    Token: '',
    PermisosWeb: '',
    IP: '',
    subscription: null
}


export const AuthContext = createContext({});

// COMPONENTE PROVIDER DEL CONTEXTO
export const AuthProvider = ({children}) => { // children: JSX.Element puede ser type any

    const [userAuth, dispatch] = useReducer(authReducer, authInitialState, );

    const signIn = (Usuario) => {
        dispatch({type: 'signIn', payload: Usuario});
    }
    const signOut = () => {
        dispatch({type: 'signOut'});
    }

    const changePermisos = (permisos) => {
        console.log(permisos)
        dispatch({type: 'changePermisos', payload: permisos});
    }

    const changeAccesos = (permisos) => {
        dispatch({type: 'changeAccesos', payload: permisos});
    }

    const setIdPersonal = (idPersonal) => {
        dispatch({type: 'setIdPersonal', payload: idPersonal});
    }

   return (
    <AuthContext.Provider value={{ 
        userAuth,
        signIn,
        signOut,
        setIdPersonal,
        changePermisos,
        changeAccesos
     }}>
        {children}
    </AuthContext.Provider>
   );
}